import { render, staticRenderFns } from "./flight-list.vue?vue&type=template&id=39052ff6&"
import script from "./flight-list.vue?vue&type=script&lang=js&"
export * from "./flight-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports